export default __webpack_public_path__ + "static/media/group-583.eb2986c9.png";